const Pagination = Vue.component('pagination', {
	props: {
		currentPage: Number,
		totalPages: Number,
	},
	template: '#pst-pagination',
	methods: {
		navigate(back = false) {
			scroll({
				top: 0,
				behavior: 'smooth',
			});
			back ? this.$emit('previous-page') : this.$emit('next-page');
		},
	},
});

const ProductCard = Vue.component('product-card', {
	props: {
		title: String,
		excerpt: String,
		link: String,
		identifier: Number,
		thumbnail: String | Boolean,
		vidyard_id: String,
	},
	template: '#pst-product-card',
	methods: {
		handleClick(e){
			e.preventDefault();
			if(e.target.dataset.vidyardModal === undefined) return;
			const vidyardID = e.target.dataset.vidyardModal;
			console.log('VIDYARD ID: ', vidyardID);
			history.pushState(null, null, '#video-'+vidyardID);
	
			$.magnificPopup.open({
				items: {
					src: `//play.vidyard.com/${vidyardID}.html?autoplay=1`
				},
				type: 'iframe',			
				callbacks: {
					close: function() {
						history.replaceState(null, null, window.location.pathname + window.location.search);
					}
				}
			});
		}
	}
});

const FiltersUI = Vue.component('filters-ui', {
	props: {
		filters: Array,
		industry: String,
		totalResults: Number,
	},
	data() {
		return {
			availableFilters: [],
		};
	},
	computed: {
		activeIndustries: function () {
			// List all the active industries.
			return this.availableFilters
				.filter((type) => type.slug === 'industry')
				.pop()
				.terms.filter((term) => term.value === true)
				.map((x) => x.slug.replace(/-/g, '_') + '_use');
		},
		availableIndustries: function () {
			return this.availableFilters
				.filter((type) => type.slug === 'industry')
				.pop()
				.terms.map((x) => x.slug.replace(/-/g, '_') + '_use');
		},
	},
	methods: {
		isProductActive(slug) {
			return this.activeIndustries.some((x) => x.startsWith(slug.substr(0, slug.length / 2)));
		},
		isProductInIndustry(slug) {
			return this.availableIndustries.some((x) =>
				x.startsWith(slug.substr(0, slug.length / 2))
			);
		},
		canDisplay(filter) {
			return filter.terms.length && filter.slug !== 'industry';
		},
		resetFilters() {
			this.availableFilters.forEach((f) => {
				f.open = false;

				f.terms.forEach((t) => {
					if (!this.industry || t.group != 'Product Types') {
						t.value = false;
					}
				});
			});

			// prepare prop for clearing input
			window.clearAllFilters = true;

			this.$emit('filters-updated', this.availableFilters);
			$('#prodSearchFromTop').parent().removeClass('placeholderMoved');
		},
		hideFilterGroup(filter) {
			return (
				this.isProductInIndustry(filter.slug) ||
				(this.industry && filter.slug == 'industry')
			);
		},
	},
	mounted() {
		if (undefined === this.filters) return;
		let queryParams = PixelsmithModules.Helpers.getUrlParams(window.location.search);

		console.log(this.industry);

		if (this.industry) {
			queryParams.industry = this.industry;
		}

		this.filters.forEach((filter) => {
			// open state for Product Types only
			let isOpen = filter.name == 'Product Types' ? true : false;

			let taxonomy = {
				name: filter.name,
				slug: filter.slug,
				terms: [],
				open: isOpen,
			};

			if (filter.terms === undefined || filter.terms.length === 0) return;

			for (const prop in filter.terms) {
				if (filter.terms.hasOwnProperty(prop)) {
					const term = filter.terms[prop];

					// make sure to skip the "Unlisted" item
					if (term.name === 'Unlisted') {
						continue;
					}

					taxonomy.terms.push({
						name: term.name,
						slug: term.slug,
						group: filter.name,
						value:
							queryParams[taxonomy.slug] &&
							queryParams[taxonomy.slug].indexOf(term.slug) > -1,
					});
				}
			}

			// filter.terms.forEach((term) => {
			// 	taxonomy.terms.push({
			// 		name: term.name,
			// 		slug: term.slug,
			// 		value: queryParams[taxonomy.slug] && queryParams[taxonomy.slug].indexOf(term.slug) > -1,
			// 	});
			// });
			this.availableFilters.push(taxonomy);
		});

		if (Object.keys(queryParams).length > 0) {
			this.$emit('filters-updated', this.availableFilters);
		}
	},
	template: '#pst-filters',
});

export const PXProductSearch = (function () {
	'use strict';

	let app;

	function init() {
		if (!document.getElementById('poly-product-search')) return;

		app = new Vue({
			el: '#poly-product-search',
			data() {
				return {
					query: '',
					allProducts: [],
					displayedProducts: [],
					filteredProducts: [],
					productFilters: [],
					totalRecords: 0,
					totalPages: 0,
					currentPage: 1,
					taxonomies: window.productTaxonomies,
					activeFilters: [],
					// industries: window.productCategories,
					activeIndustries: [],
					isFetching: false,
				};
			},
			components: {
				Pagination,
				ProductCard,
				FiltersUI,
				// ProductCategoryOptions,
			},
			mounted() {
				let queryParams = PixelsmithModules.Helpers.getUrlParams(window.location.search);

				const response = axios
					.post('/wp-json/wp/v2/banner_hero_images', { id: PXConstants.id })
					.then((response) => {
						window.heroImages = response.data;
					});

				this.fetchProducts();
			},
			methods: {
				sleep(ms) {
					return new Promise((resolve) => setTimeout(resolve, ms));
				},
				navigate(back = false) {
					if (
						(!back && this.currentPage === this.totalPages) ||
						(back && this.currentPage === 1)
					)
						return;

					back ? this.currentPage-- : this.currentPage++;

					this.updatePageProducts();
				},
				fetchProducts($ev) {
					if ($ev) $ev.preventDefault();
					this.isFetching = true;

					const queryParams = PixelsmithModules.Helpers.getUrlParams(
						window.location.search
					);

					const postData = {
						currentSiteLanguage: PXConstants.current_site_language,
						isResource: '0',
					};
					if (queryParams.lang) postData.lang = queryParams.lang;
					const searchParams = new URLSearchParams(postData).toString();

					console.log('Fetching products!');

					axios
						.get(`/wp-json/wp/v2/productsearch?${searchParams}`)
						.then((response) => {
							// fetch updated bg
							let updatedBg = '',
								currentIndustry = queryParams.industry;

							if (window.heroImages !== undefined) {
								const images = window.heroImages;

								switch (currentIndustry) {
									case 'adhesive-sealants':
										updatedBg = images.adhesive;
										break;

									case 'lubricants':
										updatedBg = images.lubricants;
										break;

									case 'specialty-products':
										updatedBg = images.specialty_products;
										break;

									case 'cleaners':
										updatedBg = images.cleaners;
										break;

									case 'mechanical-seals':
										updatedBg = images.mechanical_seats;
										break;
								}
							}

							// check if we've fetched it - if so, change the BG
							if (updatedBg) {
								const theBanner = $('.page-id-188 .pxblock--banner');

								if (theBanner.length) {
									theBanner.attr(
										'style',
										`background-image: url(${updatedBg}) !important`
									);
								}
							}

							// make sure to also remove &nbsp; from excerpt in order for it to render properly
							// does nothing as far as I can tell
							// setTimeout(() => {
							//   let content = $(
							//       '.pxblock--product-search__results .product__content'
							//     ),
							//     excerpt = content.find('.excerpt')

							//   if (excerpt.length) {
							//     $.each(excerpt, function (i, val) {
							//       let self = $(val),
							//         oldContent = self.html(),
							//         newContent = oldContent.replaceAll(/\&nbsp;/g, ' ')

							//       self.html(newContent)
							//     })
							//   }
							// }, 500)

							console.log(response.data.filter((p) => p.ID === 3764));

							// console.log(
							// 	response.data.filter((p) =>
							// 		p.post_title.toLowerCase().includes('mechanical')
							// 	)
							// );

							this.allProducts = response.data;
							this.filteredProducts = response.data;
							// this.displayedProducts = this.filteredProducts
							this.productFilters = this.getProductFilters();
							this.filterUpdateHelper();
						})
						.catch((error) => console.log(error))
						.finally(() => {
							this.isFetching = false;
						});
				},
				filterUpdateHandler($event) {
					if ($event.isTrusted) $event.preventDefault();
					else this.activeFilters = $event;

					this.filterUpdateHelper();
				},
				filterUpdateHelper() {
					if (window.clearAllFilters === true) {
						this.query = '';
						window.clearAllFilters = false;
					}

					const filters = this.getActiveFilters();

					this.updateURL();

					const taxonomyCount = Object.keys(filters).length;
					const filteredProducts = [];

					for (const [i, productFilter] of this.productFilters.entries()) {
						let matchingCount = 0;

						for (const taxonomy in productFilter) {
							if (!(taxonomy in filters)) continue;

							for (const slug of productFilter[taxonomy]) {
								if (filters[taxonomy].includes(slug)) {
									matchingCount++;
									break;
								}
							}
						}

						if (matchingCount === taxonomyCount)
							filteredProducts.push(this.allProducts[i]);
					}

					const search = this.query.toLowerCase();
					this.filteredProducts = filteredProducts.filter(function (product) {
						const title = product.post_title.toLowerCase();
						return title.includes(search);
					});

					this.totalRecords = this.filteredProducts.length;
					this.totalPages = Math.ceil(this.totalRecords / 12);
					this.currentPage = 1;
					// this.displayedProducts = this.filteredProducts
					this.updatePageProducts();

					// also remove active classes
					// $(
					//   '#poly-product-search  .pst-category-options__cats button'
					// ).removeClass('active')
				},
				// categoryUpdated(slug) {
				//   let theIndustries = Object.values(this.industries)
				//   theIndustries.forEach(ind => (ind.active = ind.slug === slug))

				//   let activeCategories = theIndustries.map(cat => {
				//     cat.value = cat.slug === slug

				//     return cat
				//   })

				//   if (this.activeFilters.length === 0) {
				//     this.activeFilters = [
				//       {
				//         slug: 'industry',
				//         name: 'Industry',
				//         terms: activeCategories,
				//       },
				//     ]
				//   } else {
				//     let hasIndustry =
				//       this.activeFilters.filter(f => f.slug === 'industry').length === 1

				//     if (hasIndustry) {
				//       this.activeFilters.forEach(f => {
				//         if (f.slug === 'industry') {
				//           f.terms.forEach(term => {
				//             term.value = term.slug === slug
				//           })
				//         }
				//       })
				//     } else {
				//       this.activeFilters.push({
				//         slug: 'industry',
				//         name: 'Industry',
				//         terms: activeCategories,
				//       })
				//     }
				//   }

				//   // this.fetchProducts()
				// },
				getActiveFilters() {
					const activeFilters = {};

					for (const filter of this.activeFilters) {
						for (const term of filter.terms) {
							if (term.value) {
								if (!(filter.slug in activeFilters))
									activeFilters[filter.slug] = [];
								activeFilters[filter.slug].push(term.slug);
							}
						}
					}

					return activeFilters;
				},
				getProductFilters() {
					const productFilters = [];

					for (const product of this.allProducts) {
						const filters = {};

						for (const taxonomy of product.taxonomies) {
							if (taxonomy.taxonomy === 'sku') continue;
							if (!(taxonomy.taxonomy in filters)) filters[taxonomy.taxonomy] = [];

							filters[taxonomy.taxonomy].push(taxonomy.slug);
						}

						productFilters.push(filters);
					}

					return productFilters;
				},
				updatePageProducts() {
					// console.log('filtered products: ', this.filteredProducts.acf.gallery[0]);
					this.displayedProducts = this.filteredProducts.slice(
						(this.currentPage - 1) * 12,
						this.currentPage * 12
					);
				},
				updateURL() {
					//TODO if industry passed in as prop don't add to url
					let filterState = {};
					let filterQueryString = '?';
					let queryParams = PixelsmithModules.Helpers.getUrlParams(
						window.location.search
					);

					this.activeFilters.forEach((f) => {
						let csvTerms = '';
						let hasAtLeastOneActiveFilter = false;

						if (f.terms === undefined || f.terms.length === 0) return;

						f.terms.forEach((term) => {
							if (term.value) hasAtLeastOneActiveFilter = true;
						});

						if (!hasAtLeastOneActiveFilter) return;

						filterQueryString += filterQueryString.length === 1 ? '' : '&';
						filterState[f.slug] = '';
						filterQueryString += f.slug + '=';

						f.terms.forEach((term, idx) => {
							if (term.value) {
								csvTerms += term.slug + ',';
							}
						});

						csvTerms = csvTerms.slice(0, -1);

						filterState[f.slug] += csvTerms;
						filterQueryString += csvTerms;
					});

					if (PXIsAdmin['admin'] !== 'true') {
						history.pushState(
							filterState,
							'New product search: ${this.query}',
							filterQueryString
						);
					}
				},
			},
		});
	}

	return {
		init: init,
	};
})();

// non Vue - jQuery section
jQuery(function ($) {
	// header class toggle
	const headerClassToggle = (() => {
		// init scroll data
		let body = $('body');

		// toggle header class
		let toggleHeaderClass = function () {
			let scrollTop = $(window).scrollTop();

			// toggle classes if scrolled
			if (scrollTop > 0) {
				body.addClass('isScrolled');
			} else {
				body.removeClass('isScrolled');
			}
		};

		// run our function on load
		toggleHeaderClass();

		// and run it again every time you scroll
		$(window).on('scroll', function () {
			toggleHeaderClass();
		});

		$('#prodSearchFromTop, #searchFromTop, #searchResourcesTop, #SDSearchFromTop').focus(
			function () {
				$(this).parent().addClass('placeholderMoved');
			}
		);

		$('#prodSearchFromTop, #searchFromTop, #searchResourcesTop, #SDSearchFromTop').blur(
			function () {
				if ($(this).val() == '') {
					$(this).parent().removeClass('placeholderMoved');
				}
			}
		);

		var prodhash = window.location.hash.substr(1);

		setTimeout(function () {
			if (prodhash) {
				$('#' + prodhash).trigger('click');
			}
		}, 1000);

		$('.pst-filters:not(.pst-filters--post-search-news) .pst-filters__filter input').on('change', handleFilterChange);
	})();

	//todo this necessary?
	function handleFilterChange() {
		// let catHash = $(this).attr('id');
		// if (history.pushState) {
		// 	var newurl =
		// 		window.location.protocol +
		// 		'//' +
		// 		window.location.host +
		// 		window.location.pathname +
		// 		'#' +
		// 		catHash;
		// 	window.history.pushState({ path: newurl }, '', newurl);
		// }
	}
});
